import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '@/services/api/utils/axiosInstance';
import { apiPath } from '@/redux/apiPath';
import { mapSchema } from '@/models/mapSchema';
import { UpdateMapPayload } from './maps.types';
import { MAPS_SLICE_NAME } from './maps.constants';

export const getProjectMaps = createAsyncThunk(
  `${MAPS_SLICE_NAME}/getProjectMaps`,
  async (projectId: string, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(apiPath.getProjectMaps(projectId));

      // Validate response data with Zod schema
      return response.data.map((map: unknown) => mapSchema.parse(map));
    } catch (error: unknown) {
      if (error instanceof Error) {
        return rejectWithValue({
          name: error.name,
          message: error.message,
        });
      }
      return rejectWithValue({
        name: 'Unknown Error',
        message: 'Failed to fetch project maps',
      });
    }
  },
);

export const updateMap = createAsyncThunk(
  `${MAPS_SLICE_NAME}/updateMap`,
  async ({ projectId, mapId, mapData }: UpdateMapPayload, { rejectWithValue }) => {
    try {
      // API expects the data wrapped in a "model" object
      const requestBody = {
        model: mapData,
      };

      const response = await axiosInstance.patch(apiPath.updateMap(projectId, mapId), requestBody);

      // Validate response data with Zod schema
      return mapSchema.parse(response.data);
    } catch (error: unknown) {
      if (error instanceof Error) {
        return rejectWithValue({
          name: error.name,
          message: error.message,
        });
      }
      return rejectWithValue({
        name: 'Unknown Error',
        message: 'Failed to update map',
      });
    }
  },
);
